import { createContext, Dispatch, SetStateAction } from "react";
import { OpenGenerateQuestionsForCMModal, RefetchCompetencyMapGenQuestionsLog } from "./components/types";
import { SelectedEntityIds, SelectionEntity, SelectionScope, SelectionTree } from "./components/Selection/types";

export interface ConstructorTabContextValue {
  skillsIdsToDelete: string[];
  setSkillsIdsToDelete: Dispatch<SetStateAction<string[]>>;
  refetchCompetencyMapGenQuestionsLog: RefetchCompetencyMapGenQuestionsLog | (() => void);
  onOpenGenerateQuestionsForCMModal: OpenGenerateQuestionsForCMModal;
  selectionScope: SelectionScope | null;
  selectionMode: boolean;
  selectedEntities: SelectedEntityIds;
  selectionTree: SelectionTree;
  onToggleSelectionMode: (scope: SelectionScope) => void;
  onClearSelectionMode: () => void;
  onToggleSelectionEntity: (entity: SelectionEntity) => void;
}

export const ConstructorTabContext = createContext<ConstructorTabContextValue>({
  skillsIdsToDelete: [],
  setSkillsIdsToDelete: () => {},
  refetchCompetencyMapGenQuestionsLog: () => {},
  onOpenGenerateQuestionsForCMModal: () => {},
  selectionScope: null,
  selectionMode: false,
  selectedEntities: {
    competencyIds: [],
    knowledgeBockIds: [],
    questionIds: [],
    skillIds: [],
  },
  selectionTree: {
    competencies: [],
    competencyMap: {},
    knowledgeBlockMap: {},
    skillMap: {},
  },
  onToggleSelectionMode: () => {},
  onClearSelectionMode: () => {},
  onToggleSelectionEntity: () => {},
});
